// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)


Vue.config.productionTip = false

/* eslint-disable no-new */
// console.log('window.rcvV2PageId:', window.rcvV2PageId);
new Vue({
  el: '#app',
  router,
  provide: {
    rcvV2PageId: window.rcvV2PageId
  },
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js